var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCenterCam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 170.7",
    style: {
      enableBackground: "new 0 0 170 170.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000154411194154587951890000011404457809096448436_);}\r\n\t.st1{fill:#525660;}\r\n\t.st2{fill:#95B4CF;}\r\n\t.st3{clip-path:url(#SVGID_00000149369329778477527390000013667340775439478702_);}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{opacity:0.5;fill:#525660;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#6A6A65;}\r\n\t.st8{clip-path:url(#SVGID_00000101101570158454511780000016987030168884076199_);}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#735F5D;}\r\n\t.st10{clip-path:url(#SVGID_00000163757108313686938280000007682536890959115420_);}\r\n\t.st11{display:none;}\r\n\t.st12{display:inline;}\r\n\t.st13{clip-path:url(#SVGID_00000133500451596795651980000013617609445304878512_);}\r\n\t.st14{clip-path:url(#SVGID_00000096763443917346392810000016485229197867937468_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72.7,62.8 67.5,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.4,80.1 65.4,60.8 76.1,60.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "102,62.8 97,62.8 102,71.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.1,79.7 93.5,60.8 104.1,60.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "96.1,61.2 73.6,61.2 72.7,62.8 97,62.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,140.4c-0.4,0.7-1.2,1.1-2,1.1c-0.2,0-0.4,0-0.6-0.1c-1-0.3-1.7-1.2-1.7-2.2V64.5c0-2,1.7-3.7,3.7-3.7 h37.5v12l-4,7.3l-0.1-8.3v-6.9H32.3v67.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.5,141.3 102,141.3 102,71.9 97,62.8 72.7,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1,143.3H65.4V71.7l6.1-10.9h26.7l5.9,10.6V143.3z M69.5,139.3H100V72.4l-4.2-7.6H73.9l-4.4,7.9V139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.5,141.3 102,141.3 102,71.9 97,62.8 72.7,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1,143.3H65.4V71.7l6.1-10.9h26.7l5.9,10.6V143.3z M69.5,139.3H100V72.4l-4.2-7.6H73.9l-4.4,7.9V139.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.5,132.4V64.9h-33.1v6.9l-0.3,7.9l-3.8-6.9v-12h37.5c2,0,3.7,1.7,3.7,3.7v74.7c0,1-0.7,1.9-1.7,2.2 c-0.2,0.1-0.4,0.1-0.6,0.1c-0.8,0-1.5-0.4-2-1.1l0-0.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.5,13.2v49h49v-49H59.5z M100.3,45.9c0,2.2-1.8,4.1-4.1,4.1h-9.1l6.4,6.4c0.7,0.6,0.2,1.7-0.7,1.7H75.2 c-0.9,0-1.4-1.1-0.7-1.7l6.4-6.4h-9.1c-2.2,0-4.1-1.8-4.1-4.1V21.4c0-2.2,1.8-4.1,4.1-4.1h24.5c2.2,0,4.1,1.8,4.1,4.1V45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,17.3H71.7c-2.2,0-4.1,1.8-4.1,4.1v24.5c0,2.2,1.8,4.1,4.1,4.1h9.1l-6.4,6.4c-0.7,0.6-0.2,1.7,0.7,1.7 h17.6c0.9,0,1.4-1.1,0.7-1.7L87.1,50h9.1c2.2,0,4.1-1.8,4.1-4.1V21.4C100.3,19.2,98.5,17.3,96.2,17.3z M84,25.1 c2.2,0,4.1,1.8,4.1,4.1c0,2.2-1.8,4.1-4.1,4.1c-2.2,0-4.1-1.8-4.1-4.1C79.9,26.9,81.7,25.1,84,25.1z M92.2,41.4H75.8v-1.2 c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2c2,0,3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8V41.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.2,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.6,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.7,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.9,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.3,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.2,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.6,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.8,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.7,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.7,144.9h-6.6h-3.3h-0.4l-0.1,0l0.2,0c0.1,0,0.2,0,0.3,0c0.4,0,0.8,0.1,1.2,0.3 c0.8,0.3,1.4,0.8,1.9,1.5l-12,8.9c1.1,1.6,2.7,2.8,4.5,3.5c0.9,0.4,1.9,0.6,2.8,0.7c0.2,0,0.5,0,0.7,0l0.5,0h0.4h3.3h6.6 V144.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M33.9,152.9v-1.5h-0.6c-0.2,0-0.3,0-0.4,0c-0.3-0.1-0.5-0.2-0.8-0.3l-0.9,1.2c0.4,0.3,0.8,0.5,1.3,0.6 c0.2,0,0.5,0.1,0.7,0.1H33.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3,
    y: 151.4,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.9,146.7c0.5,0.7,0.8,1.5,0.9,2.3c0.1,0.8-0.1,1.7-0.5,2.4c-0.4,0.7-0.9,1.4-1.7,1.8 c-0.7,0.4-1.6,0.7-2.4,0.7h6.6v-15h-6.6c-1.9,0-3.9,0.5-5.5,1.6c-1.6,1-3,2.5-3.9,4.2c-0.9,1.7-1.2,3.7-1.1,5.6 c0.2,1.9,0.9,3.8,2,5.4L36.9,146.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M31.9,146.2l0.6,1.4c0.3-0.1,0.5-0.2,0.8-0.2h1.2v-1.5h-1.2C32.8,145.9,32.3,146,31.9,146.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M29.9,150.4l1.4-0.4c-0.2-0.5-0.1-1.1,0.2-1.6l-1.3-0.7C29.7,148.5,29.6,149.5,29.9,150.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.9,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.2,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 76.2,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.4,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.7,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.7,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.9,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 102.7,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.6,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.4,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 129.2,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M132.7,153.9h3.3h0.4l0.1,0l-0.2,0c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.1-1.2-0.3c-0.8-0.3-1.4-0.8-1.9-1.5 c-0.5-0.7-0.8-1.5-0.9-2.3c-0.1-0.8,0.1-1.7,0.5-2.4c0.4-0.7,0.9-1.4,1.7-1.8c0.7-0.4,1.6-0.7,2.4-0.7v15 c1.9,0,3.9-0.5,5.5-1.6c1.6-1,3-2.5,3.9-4.2c0.9-1.7,1.2-3.7,1.1-5.6c-0.2-1.9-0.9-3.8-2-5.4c-1.1-1.6-2.7-2.8-4.5-3.5 c-0.9-0.4-1.9-0.6-2.8-0.7c-0.2,0-0.5,0-0.7,0l-0.5,0H136h-3.3V153.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M139.7,150.8l-1.4-0.6c-0.2,0.5-0.7,0.9-1.2,1.1l0.5,1.4C138.5,152.4,139.3,151.7,139.7,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M138.3,146.3l-0.8,1.3c0.5,0.3,0.8,0.8,1,1.3l1.5-0.3C139.7,147.7,139.1,146.8,138.3,146.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.7,
    y: 145.9,
    className: "st7",
    width: 2.5,
    height: 1.5
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_copia_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.8,139.7V72.2l-37,66.8c-0.1,0.2-0.2,0.5-0.2,0.7v0c0,0.8,0.7,1.5,1.5,1.5h34.1 C67.1,141.2,67.8,140.5,67.8,139.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33,139.2h32.8V80l-0.4-5.4c0.6-0.1,1.2-0.1,1.7,0c1.6,0.4,2.7,1.8,2.7,3.4v61.6c0,2-1.6,3.5-3.5,3.5H32.2 c-2,0-3.5-1.6-3.5-3.5c0-0.6,0.2-1.2,0.4-1.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72.7,62.8 67.5,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.4,80.1 65.4,60.8 76.1,60.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "102,62.8 97,62.8 102,71.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.1,79.7 93.5,60.8 104.1,60.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "96.1,61.2 73.6,61.2 72.7,62.8 97,62.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,140.4c-0.4,0.7-1.2,1.1-2,1.1c-0.2,0-0.4,0-0.6-0.1c-1-0.3-1.7-1.2-1.7-2.2V64.5c0-2,1.7-3.7,3.7-3.7 h37.5v12l-3.8,7l-0.2-8.1v-6.9H32.3v67.5L32.5,140.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 62.8,
    className: "st4",
    width: 30.5,
    height: 11.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "67.5,141.3 102,141.3 102,71.9 97,62.8 72.7,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.5,62.7l2-1.9h26.7l4.1,2.8l1.7,7.7v71.9H65.4V71.7l4-7.3v8.3v66.5H100V72.4v-7.6h-4.2H68.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.3,141.1V73c0-0.2,0.3-0.3,0.3-0.1l36.6,66.2c0.1,0.2,0.2,0.5,0.2,0.7v1.3c0,0.1-0.1,0.2-0.2,0.2h-36.8 C102.4,141.3,102.3,141.2,102.3,141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.5,131.6l3.6,6.5c0.3,0.5,0.4,1.1,0.4,1.7c0,2-1.6,3.5-3.5,3.5h-34.1c-2,0-3.5-1.6-3.5-3.5V78.1 c0-1.6,1.1-13,2.7-13.4c0.4-0.1,0.8-0.1,1.2-0.1l0.2,15.5v59.2h32.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.5,13.2v49h49v-49H59.5z M100.3,45.9c0,2.2-1.8,4.1-4.1,4.1h-9.1l6.4,6.4c0.7,0.6,0.2,1.7-0.7,1.7H75.2 c-0.9,0-1.4-1.1-0.7-1.7l6.4-6.4h-9.1c-2.2,0-4.1-1.8-4.1-4.1V21.4c0-2.2,1.8-4.1,4.1-4.1h24.5c2.2,0,4.1,1.8,4.1,4.1V45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,17.3H71.7c-2.2,0-4.1,1.8-4.1,4.1v24.5c0,2.2,1.8,4.1,4.1,4.1h9.1l-6.4,6.4c-0.7,0.6-0.2,1.7,0.7,1.7 h17.6c0.9,0,1.4-1.1,0.7-1.7L87.1,50h9.1c2.2,0,4.1-1.8,4.1-4.1V21.4C100.3,19.2,98.5,17.3,96.2,17.3z M84,25.1 c2.2,0,4.1,1.8,4.1,4.1c0,2.2-1.8,4.1-4.1,4.1c-2.2,0-4.1-1.8-4.1-4.1C79.9,26.9,81.7,25.1,84,25.1z M92.2,41.4H75.8v-1.2 c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2c2,0,3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8V41.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.5,152.4H33.3c-1.7,0-3-1.3-3-3v0c0-1.7,1.3-3,3-3h103.2c1.7,0,3,1.3,3,3l0,0 C139.5,151,138.1,152.4,136.5,152.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.2,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.2,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.6,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.4,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.8,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 96.7,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.7,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.1,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.5,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.5,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.5,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.9,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.3,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.2,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.2,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.6,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.8,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.7,
    y: 144.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.7,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.1,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M43.7,144.9h-6.6h-3.3h-0.4l-0.1,0l0.2,0c0.1,0,0.2,0,0.3,0c0.4,0,0.8,0.1,1.2,0.3 c0.8,0.3,1.4,0.8,1.9,1.5l-12,8.9c1.1,1.6,2.7,2.8,4.5,3.5c0.9,0.4,1.9,0.6,2.8,0.7c0.2,0,0.5,0,0.7,0l0.5,0h0.4h3.3h6.6 V144.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M33.9,152.9v-1.5h-0.6c-0.2,0-0.3,0-0.4,0c-0.3-0.1-0.5-0.2-0.8-0.3l-0.9,1.2c0.4,0.3,0.8,0.5,1.3,0.6 c0.2,0,0.5,0.1,0.7,0.1H33.9z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.9,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3,
    y: 151.4,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.9,146.7c0.5,0.7,0.8,1.5,0.9,2.3c0.1,0.8-0.1,1.7-0.5,2.4c-0.4,0.7-0.9,1.4-1.7,1.8 c-0.7,0.4-1.6,0.7-2.4,0.7h6.6v-15h-6.6c-1.9,0-3.9,0.5-5.5,1.6c-1.6,1-3,2.5-3.9,4.2c-0.9,1.7-1.2,3.7-1.1,5.6 c0.2,1.9,0.9,3.8,2,5.4L36.9,146.7z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M31.9,146.2l0.6,1.4c0.3-0.1,0.5-0.2,0.8-0.2h1.2v-1.5h-1.2C32.8,145.9,32.3,146,31.9,146.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M29.9,150.4l1.4-0.4c-0.2-0.5-0.1-1.1,0.2-1.6l-1.3-0.7C29.7,148.5,29.6,149.5,29.9,150.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.9,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 49.7,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.3,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.9,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.2,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.6,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.2,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 76.2,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.4,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 79.7,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.7,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 92.9,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 102.7,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.9,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 106.2,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.6,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.4,
    y: 138.9,
    className: "st6",
    width: 13.3,
    height: 15
  })), /*#__PURE__*/React.createElement("rect", {
    x: 129.2,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.4,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M132.7,153.9h3.3h0.4l0.1,0l-0.2,0c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8-0.1-1.2-0.3c-0.8-0.3-1.4-0.8-1.9-1.5 c-0.5-0.7-0.8-1.5-0.9-2.3c-0.1-0.8,0.1-1.7,0.5-2.4c0.4-0.7,0.9-1.4,1.7-1.8c0.7-0.4,1.6-0.7,2.4-0.7v15 c1.9,0,3.9-0.5,5.5-1.6c1.6-1,3-2.5,3.9-4.2c0.9-1.7,1.2-3.7,1.1-5.6c-0.2-1.9-0.9-3.8-2-5.4c-1.1-1.6-2.7-2.8-4.5-3.5 c-0.9-0.4-1.9-0.6-2.8-0.7c-0.2,0-0.5,0-0.7,0l-0.5,0H136h-3.3V153.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M139.7,150.8l-1.4-0.6c-0.2,0.5-0.7,0.9-1.2,1.1l0.5,1.4C138.5,152.4,139.3,151.7,139.7,150.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M138.3,146.3l-0.8,1.3c0.5,0.3,0.8,0.8,1,1.3l1.5-0.3C139.7,147.7,139.1,146.8,138.3,146.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.7,
    y: 145.9,
    className: "st9",
    width: 2.5,
    height: 1.5
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "72.7,62.8 67.5,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.4,80.1 65.4,60.8 76.1,60.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "102,62.8 97,62.8 102,71.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "104.1,79.7 93.5,60.8 104.1,60.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "96.1,61.2 73.6,61.2 72.7,62.8 97,62.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.5,141.5c-0.2,0-0.4,0-0.6-0.1c-1-0.3-1.7-1.2-1.7-2.2V64.5c0-2,1.7-3.7,3.7-3.7h37.5v12l-37,67.6 C32.1,141.1,31.3,141.5,30.5,141.5z M32.3,64.9v67.5l33.1-60.6v-6.9H32.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,139.8V78.1c0-1.6-2.1-2.1-2.8-0.7L30.5,139c-0.1,0.2-0.2,0.5-0.2,0.7l0,0c0,0.8,0.7,1.5,1.5,1.5h34.1 C66.8,141.3,67.5,140.6,67.5,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.9,143.3H31.8c-2,0-3.5-1.6-3.5-3.5c0-0.6,0.2-1.2,0.4-1.7l34.1-61.6c0.8-1.4,2.4-2.1,4-1.7 c1.6,0.4,2.7,1.8,2.7,3.4v61.6C69.5,141.7,67.9,143.3,65.9,143.3z M32.7,139.3h32.8V80.1L32.7,139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.5,139.8V78.1c0-1.6-2.1-2.1-2.8-0.7L30.5,139c-0.1,0.2-0.2,0.5-0.2,0.7l0,0c0,0.8,0.7,1.5,1.5,1.5h34.1 C66.8,141.3,67.5,140.6,67.5,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.9,143.3H31.8c-2,0-3.5-1.6-3.5-3.5c0-0.6,0.2-1.2,0.4-1.7l34.1-61.6c0.8-1.4,2.4-2.1,4-1.7 c1.6,0.4,2.7,1.8,2.7,3.4v61.6C69.5,141.7,67.9,143.3,65.9,143.3z M32.7,139.3h32.8V80.1L32.7,139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.5,141.3 102,141.3 102,71.9 97,62.8 72.7,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1,143.3H65.4V71.7l6.1-10.9h26.7l5.9,10.6V143.3z M69.5,139.3H100V72.4l-4.2-7.6H73.9l-4.4,7.9V139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "67.5,141.3 102,141.3 102,71.9 97,62.8 72.7,62.8 67.5,72.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.1,143.3H65.4V71.7l6.1-10.9h26.7l5.9,10.6V143.3z M69.5,139.3H100V72.4l-4.2-7.6H73.9l-4.4,7.9V139.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,141.5c-0.8,0-1.5-0.4-2-1.1l0-0.1l-36.9-67.6v-12h37.5c2,0,3.7,1.7,3.7,3.7v74.7c0,1-0.7,1.9-1.7,2.2 C139.6,141.5,139.4,141.5,139.2,141.5z M104.3,71.7l33.1,60.6V64.9h-33.1V71.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.3,139.8V78.1c0-1.6,2.1-2.1,2.8-0.7l34.1,61.6c0.1,0.2,0.2,0.5,0.2,0.7l0,0c0,0.8-0.7,1.5-1.5,1.5 h-34.1C103,141.3,102.3,140.6,102.3,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138,143.3h-34.1c-2,0-3.5-1.6-3.5-3.5V78.1c0-1.6,1.1-3,2.7-3.4c1.6-0.4,3.2,0.3,4,1.7l34.1,61.6 c0.3,0.5,0.4,1.1,0.4,1.7C141.5,141.7,139.9,143.3,138,143.3z M104.3,139.3h32.8l-32.8-59.2V139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.3,139.8V78.1c0-1.6,2.1-2.1,2.8-0.7l34.1,61.6c0.1,0.2,0.2,0.5,0.2,0.7l0,0c0,0.8-0.7,1.5-1.5,1.5 h-34.1C103,141.3,102.3,140.6,102.3,139.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138,143.3h-34.1c-2,0-3.5-1.6-3.5-3.5V78.1c0-1.6,1.1-3,2.7-3.4c1.6-0.4,3.2,0.3,4,1.7l34.1,61.6 c0.3,0.5,0.4,1.1,0.4,1.7C141.5,141.7,139.9,143.3,138,143.3z M104.3,139.3h32.8l-32.8-59.2V139.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M59.5,13.2v49h49v-49H59.5z M100.3,45.9c0,2.2-1.8,4.1-4.1,4.1h-9.1l6.4,6.4c0.7,0.6,0.2,1.7-0.7,1.7H75.2 c-0.9,0-1.4-1.1-0.7-1.7l6.4-6.4h-9.1c-2.2,0-4.1-1.8-4.1-4.1V21.4c0-2.2,1.8-4.1,4.1-4.1h24.5c2.2,0,4.1,1.8,4.1,4.1V45.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.2,17.3H71.7c-2.2,0-4.1,1.8-4.1,4.1v24.5c0,2.2,1.8,4.1,4.1,4.1h9.1l-6.4,6.4c-0.7,0.6-0.2,1.7,0.7,1.7 h17.6c0.9,0,1.4-1.1,0.7-1.7L87.1,50h9.1c2.2,0,4.1-1.8,4.1-4.1V21.4C100.3,19.2,98.5,17.3,96.2,17.3z M84,25.1 c2.2,0,4.1,1.8,4.1,4.1c0,2.2-1.8,4.1-4.1,4.1c-2.2,0-4.1-1.8-4.1-4.1C79.9,26.9,81.7,25.1,84,25.1z M92.2,41.4H75.8v-1.2 c0-1.7,1-3.1,2.5-3.8c1.7-0.8,3.7-1.2,5.7-1.2c2,0,3.9,0.4,5.7,1.2c1.5,0.7,2.5,2.1,2.5,3.8V41.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterCam);
export default __webpack_public_path__ + "static/media/CenterCam.666ac07c9cce953db0f485ce4b9642ab.svg";
export { ForwardRef as ReactComponent };